import React from "react";
import {DashboardJobOrderCount} from "../../types/DashboardJobOrderCount";
import {DashboardCountBox} from "./DashboardCountBox";

interface JobOrderRowProps {
    jobOrderCount: DashboardJobOrderCount;
}

export let JobOrderRow = function (props: JobOrderRowProps) {
    return (
        <div className="dispatch-orders-box-job-row" data-job-id={props.jobOrderCount.job_id}>
            <div className="dispatch-orders-box-job-name">{props.jobOrderCount.job_name}</div>
            <div className="dispatch-orders-box-counts">
                <DashboardCountBox variant="pending" count={props.jobOrderCount.pending_count}/>
                <DashboardCountBox variant="confirmed" count={props.jobOrderCount.confirmed_count}/>
            </div>
        </div>
    );
};
